export default "__VITE_ASSET__opd$7AMN__"